export default __webpack_public_path__ + "static/media/res1.a512ca3e.PNG";